/**
 * `ReportsScene` projection — the six cards of the demo's empty report pane
 * (`renderReports` with no kind, demo line 2654), each resolved to where the
 * report opens, the question that builds it, and the format it carries.
 *
 * Pure: reads the catalogue only.
 *
 * @see src/versions/v1/modules/reports/ReportsScene.tsx
 * @see docs/logic/reports/overview.md
 */

import type { ReportFormat, ReportKind } from '../../schema/report';
import {
  REPORT_CARDS,
  REPORT_DOWNLOAD,
  REPORT_FORMAT,
  reportPath,
  reportPrompt,
} from '../../shared/report-catalog';

/** One card, ready to render. */
export interface ReportCardView {
  readonly kind: ReportKind;
  readonly title: string;
  readonly desc: string;
  /** The demo's format tag — DOCX, EML, PPTX. */
  readonly format: ReportFormat;
  /** What Download produces here, or "in-app" for the S.O.S report. */
  readonly downloadLabel: string;
  readonly path: string;
  readonly prompt: string;
}

/** Demo 2654. The six cards, in the demo's order. */
export function reportCards(): ReportCardView[] {
  return REPORT_CARDS.map((card) => {
    const download = REPORT_DOWNLOAD[card.ref.kind];
    return {
      kind: card.ref.kind,
      title: card.title,
      desc: card.desc,
      format: REPORT_FORMAT[card.ref.kind],
      downloadLabel: download ? `Downloads as ${download.toUpperCase()}` : 'In-app only',
      path: reportPath(card.ref),
      prompt: reportPrompt(card.ref),
    };
  });
}
